import {generalRequest} from "@/lib/services/requests";
import {useQuery} from "@tanstack/react-query";

export const useApiSearchStudentInstallments = (args) => {
    return useQuery({
        queryKey: ['student', 'payment', 'list', args],
        queryFn: ({pageParam = args.page ?? 1}) => (((config) => {
            return generalRequest.get(`/student/installments`, {params: config})
        })({...args, page: pageParam})),
    })
}